interface FilterTabsProps {
    activeTab: string;
    onTabChange: (tab: string) => void;
    counts: { all: number; paid: number; demo: number; expired: number };
}

const TABS = [
    { key: "all", label: "All" },
    { key: "paid", label: "Paid" },
    { key: "demo", label: "Demo" },
    { key: "expired", label: "Expired" },
] as const;

export const FilterTabs = ({ activeTab, onTabChange, counts }: FilterTabsProps) => {
    return (
        <div className="sam-filter-tabs">
            {TABS.map(({ key, label }) => (
                <button
                    key={key}
                    className={`sam-tab ${activeTab === key ? "active" : ""}`}
                    onClick={() => onTabChange(key)}
                >
                    {label} ({counts[key as keyof typeof counts]})
                </button>
            ))}
        </div>
    );
};
